import { createFileRoute } from '@tanstack/react-router';
import CompanyDocumentRequests from '@/modules/document-requests/pages/company-document-requests';

export const Route = createFileRoute(
  '/_authenticated/_system/_company/my-document-requests/',
)({
  head: () => ({
    meta: [{ title: 'Solicitações de Documentos' }],
  }),
  component: CompanyDocumentRequests,
});
